let http='https://apis.huiansmart.com'//本地

export const api={
    apply:http+'/web/api/v1/currency/ha-apple-for-trial',
  }
